<template>
  <label class="wt2-toggle-component" :class="{ '-disabled': disabled }">
    <span v-if="labelLeft" v-once class="-label-left" v-text="labelLeft" />
    <input
      type="checkbox"
      v-once
      :checked="checked"
      :disabled="disabled"
      @change="onChange($event)"
      ref="input"
    />
    <span v-once class="-body" />
    <span v-if="labelRight" v-once class="-label-right" v-text="labelRight" />
  </label>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'toggle',
  },

  props: {
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    labelLeft: {
      type: String,
      required: false,
      default: '',
    },
    labelRight: {
      type: String,
      required: false,
      default: '',
    },
  },

  watch: {
    checked() {
      this.$refs.input.checked = this.checked;
    },
    disabled() {
      this.$refs.input.disabled = this.disabled;
    },
  },

  data() {
    return {};
  },

  methods: {
    onChange(e) {
      this.$emit('toggle', e.target.checked);
    },
  },
};
</script>
